import { Observable } from 'rxjs';
import { User } from '../../../profile/root';

export abstract class UserAccountAdapter {
  abstract load(): Observable<User>;
}
